import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api } from '@.api';
import { BrandListResponse } from '@.api/methods';
import { BrandIndexResource } from '@/entities/Brand/api';
import { useArchiveBrand, useRestoreBrand } from '@/features/BrandActionConfirmModal/model';
import { useDeleteBrand } from '@/features/DeleteBrand/lib';
import { Auth } from '@/Services';
import { Request } from '@/Types';

export const useAllBrandsPageControl = () => {
    const auth = Auth.Use();

    const get = useCallback((q?: Request.All) => Api.brands().getAll(q), []);

    const navigate = useNavigate();

    const restoreBrand = useRestoreBrand();
    const archiveBrand = useArchiveBrand();

    const deleteBrandControl = useDeleteBrand({ onSuccessDelete: () => navigate(0) });

    const getData = useCallback((data: BrandListResponse) => data.brands, []);

    const items = useCallback((item: BrandIndexResource) => ({ className: item.deleted_at ? 'deleted' : '' }), []);

    const modals = [restoreBrand.modal, archiveBrand.modal, deleteBrandControl.modal];

    return {
        modals,
        modalDelete: deleteBrandControl.modal,
        deleteBrand: deleteBrandControl.deleteBrand,
        auth,
        get,
        items,
        getData,
        handleArchive: archiveBrand.handleArchive,
        handleRestore: restoreBrand.handleRestore,
    };
};
